<template>
  <div class="">
    <DashboardNavbar
      v-on:updateViewType="updateViewType(modelName, $event)"
      :viewType="generalSetting[modelName].viewType"
      :viewTypeStatus="true"
      v-on:updateActivationTypeTokens="changeActivationType($event)"
      :activationTypeTokens="generalSetting[modelName].activationTypeTokens"
      :activationTypesTokensOptions="activationTypesTokensOptions"
      :activationTypeStatus="true"
      :btnAddTitle="$t('StorageSpaces.media.add')"
      :btnAddName="'StorageSpaceMediaAdd'"
      :btnAddStatus="hasPrivilegeAdd"
      :filterSheetName="'filterSheet'"
      :filterSheetStatus="true"
    />
    <PreLoader v-if="isLoading" />

    <div class="app-content pagination-with-content">
      <b-tabs v-if="mediaTypesOptions">
        <b-tab
          v-for="(option, index) in mediaTypesOptions"
          :key="index"
          @click="filterByMediaType(option.value)"
          :title-item-class="'custom-tab-outer-li tab-container-media'"
        >
          <template #title>
            <span v-b-popover.hover.bottomright="`${option.text}`">
              <!-- <b-badge variant="danger" class="count-notifications">{{
                option.itemTotalInnerCount
              }}</b-badge> -->
              <!-- :src="baseUrl + option.image" -->
              <img
                :src="
                  fullPathFileFromServer(
                    option.image,
                    storageSpaceMedias.storageSpaceMedia.icon
                  )
                "
                :onerror="`this.src='${storageSpaceMedias.storageSpaceMedia.icon}'`"
                class="icon-tab"
              />
              <span>{{ option.text }}</span>
            </span>
          </template>
        </b-tab>
      </b-tabs>
      <template v-if="hasData">
        <StorageSpaceMediaTable
          v-if="generalSetting[modelName].viewType == VIEW_TYPES.table"
          v-on:setStorageSpaceMediaData="
            storageSpaceMedias.storageSpaceMedia.fillData($event)
          "
          :storageSpaceMediaData="storageSpaceMedias.storageSpaceMediaData"
          :defaultImg="storageSpaceMedias.storageSpaceMedia.defaultImg"
          :filterData="storageSpaceMedias.filterData"
        />

        <StorageSpaceMediaCards
          v-else-if="generalSetting[modelName].viewType == VIEW_TYPES.cards"
          v-on:setStorageSpaceMediaData="
            storageSpaceMedias.storageSpaceMedia.fillData($event)
          "
          :storageSpaceMediasData="storageSpaceMedias.storageSpaceMediaData"
          :defaultImg="storageSpaceMedias.storageSpaceMedia.defaultImg"
          :filterData="storageSpaceMedias.filterData"
        />

        <ActionsData :actionsData="storageSpaceMedias.storageSpaceMedia" />
        <StorageSpaceMediaInfo
          :storageSpaceMedia="storageSpaceMedias.storageSpaceMedia"
        />
        <StorageSpaceMediaDelete
          :storageSpaceMedia="storageSpaceMedias.storageSpaceMedia"
          v-on:refresh="getAllStorageSpaceMedias()"
        />
        <StorageSpaceMediaChangeActivationType
          :storageSpaceMedia="storageSpaceMedias.storageSpaceMedia"
          v-on:refresh="getAllStorageSpaceMedias()"
        />
        <CustomBottomSheetQRCode
          :refName="'StorageSpaceMediaQRCode'"
          :code="storageSpaceMedias.storageSpaceMedia.fullCode"
          :codeTitle="$t('StorageSpaces.media.code')"
          :name="
            storageSpaceMedias.storageSpaceMedia.storageSpaceMediaNameCurrent
          "
          :nameTitle="$t('StorageSpaces.media.name')"
          :nameIcon="'media.svg'"
        />
      </template>
      <ExceptionWithImg
        v-if="exceptionMsg"
        :msg="exceptionMsg"
        :image="exceptionImg"
      />
      <CustomPagination
        v-if="hasData"
        :paginationData="storageSpaceMedias.filterData"
        v-on:changePagination="changePagination($event)"
      />
      <StorageSpaceMediaFilter
        :theFilterData="storageSpaceMedias.filterData"
        v-on:search="search($event)"
      />

      <StorageSpaceMediaAdd
        :storageSpaceMedia="storageSpaceMedias.storageSpaceMedia"
        v-on:refresh="getAllStorageSpaceMedias()"
        :mainToken="storageSpaceMedias.filterData.mainToken"
      />
      <StorageSpaceMediaUpdate
        :storageSpaceMedia="storageSpaceMedias.storageSpaceMedia"
        v-on:refresh="getAllStorageSpaceMedias()"
      />
    </div>
  </div>
</template>

<script>
import { STATUS, VIEW_TYPES } from "./../../utils/constants";
import { ACTIVATION_TYPE } from "./../../utils/constantLists";
import DashboardNavbar from "./../../layouts/components/DashboardNavbar.vue";
import PreLoader from "./../../components/general/PreLoader.vue";
import ExceptionWithImg from "./../../components/general/ExceptionWithImg.vue";
import ActionsData from "./../../components/general/ActionsData.vue";
import CustomBottomSheetQRCode from "./../../components/general/CustomBottomSheetQRCode.vue";
import CustomPagination from "./../../components/general/CustomPagination.vue";
import StorageSpaceMediaAdd from "./components/StorageSpaceMediaAdd.vue";
import StorageSpaceMediaUpdate from "./components/StorageSpaceMediaUpdate.vue";
import StorageSpaceMediaCards from "./components/StorageSpaceMediaCards.vue";
import StorageSpaceMediaTable from "./components/StorageSpaceMediaTable.vue";
import StorageSpaceMediaInfo from "./components/StorageSpaceMediaInfo.vue";
import StorageSpaceMediaDelete from "./components/StorageSpaceMediaDelete.vue";
import StorageSpaceMediaChangeActivationType from "./components/StorageSpaceMediaChangeActivationType.vue";
import StorageSpaceMediaFilter from "./components/StorageSpaceMediaFilter.vue";
import StorageSpaceMedias from "./../../models/storageSpaceMedias/StorageSpaceMedias";
import apiStorageSpaceMedia from "./../../api/storageSpaceMedia";
import {
  getDialogOfActivationTypes,
  getDialogOfMediaTypes,
} from "./../../utils/dialogsOfConstantsLists";
import generalMixin from "./../../utils/generalMixin";
import generalSettingsMixin from "./../../utils/generalSettingsMixin";
import {
  checkPrivilege,
  fullPathFileFromServer,
} from "./../../utils/functions";
import {
  hasStorageSpaceMediaAdminsEgyptAdd,
  hasStorageSpaceMediaAdminsEgyptViewActive,
  hasStorageSpaceMediaAdminsEgyptViewArchive,
  hasStorageSpaceMediaAdminsEgyptViewBlocked,
  hasStorageSpaceMediaMasterAdminAdd,
  hasStorageSpaceMediaMasterAdminViewActive,
  hasStorageSpaceMediaMasterAdminViewArchive,
  hasStorageSpaceMediaMasterAdminViewBlocked,
  hasStorageSpaceMediaEmployeeAdd,
  hasStorageSpaceMediaEmployeeViewActive,
  hasStorageSpaceMediaEmployeeViewArchive,
  hasStorageSpaceMediaEmployeeViewBlocked,
  hasStorageSpaceMediaStudentAdd,
  hasStorageSpaceMediaStudentViewActive,
  hasStorageSpaceMediaStudentViewArchive,
  hasStorageSpaceMediaStudentViewBlocked,
  hasStorageSpaceMediaPlaceAdd,
  hasStorageSpaceMediaPlaceViewActive,
  hasStorageSpaceMediaPlaceViewArchive,
  hasStorageSpaceMediaPlaceViewBlocked,
  hasStorageSpaceMediaEducationalGroupAdd,
  hasStorageSpaceMediaEducationalGroupViewActive,
  hasStorageSpaceMediaEducationalGroupViewArchive,
  hasStorageSpaceMediaEducationalGroupViewBlocked,
} from "./../../utils/privilegeHelper";

export default {
  mixins: [generalMixin, generalSettingsMixin],
  components: {
    DashboardNavbar,
    PreLoader,
    ExceptionWithImg,
    ActionsData,
    CustomBottomSheetQRCode,
    CustomPagination,
    StorageSpaceMediaAdd,
    StorageSpaceMediaUpdate,
    StorageSpaceMediaCards,
    StorageSpaceMediaTable,
    StorageSpaceMediaInfo,
    StorageSpaceMediaDelete,
    StorageSpaceMediaChangeActivationType,
    StorageSpaceMediaFilter,
  },
  computed: {
    hasData() {
      return this.storageSpaceMedias.storageSpaceMediaData.length != 0;
    },
    activationTypesTokensOptions: function () {
      let options = [];
      switch (this.modelName) {
        case "storageSpaceMediasAdminsEgypt":
          options = this.getActivationTypeTokenOptionAdminsEgypt();
          break;
        case "storageSpaceMediasMasterAdmin":
          options = this.getActivationTypeTokenOptionMasterAdmin();
          break;
        case "storageSpaceMediasEmployees":
          options = this.getActivationTypeTokenOptionEmployees();
          break;
        case "storageSpaceMediasStudents":
          options = this.getActivationTypeTokenOptionStudent();
          break;
        case "storageSpaceMediasPlaces":
          options = this.getActivationTypeTokenOptionPlaces();
          break;
        case "storageSpaceMediasEducationalGroup":
          options = this.getActivationTypeTokenOptionEducationalGroup();
          break;
        default:
          break;
      }
      return options;
    },
    hasPrivilegeAdd() {
      let status = false;
      switch (this.modelName) {
        case "storageSpaceMediasAdminsEgypt":
          status = checkPrivilege(hasStorageSpaceMediaAdminsEgyptAdd());
          break;
        case "storageSpaceMediasMasterAdmin":
          status = checkPrivilege(hasStorageSpaceMediaMasterAdminAdd());
          break;
        case "storageSpaceMediasEmployees":
          status = checkPrivilege(hasStorageSpaceMediaEmployeeAdd());
          break;
        case "storageSpaceMediasStudents":
          status = checkPrivilege(hasStorageSpaceMediaStudentAdd());
          break;
        case "storageSpaceMediasPlaces":
          status = checkPrivilege(hasStorageSpaceMediaPlaceAdd());
          break;
        case "storageSpaceMediasEducationalGroup":
          status = checkPrivilege(hasStorageSpaceMediaEducationalGroupAdd());
          break;
        default:
          break;
      }
      return status;
    },
  },
  props: {
    // modelName: {
    //   type: String,
    //   default: "",
    // },
    // storageSpaceMediaTypeToken: {
    //   type: String,
    //   default: "",
    // },
    // mainToken: {
    //   type: String,
    //   default: "",
    // },
  },
  data() {
    return {
      mediaTypesOptions: getDialogOfMediaTypes(),
      currentTab: "",
      storageSpaceMedias: new StorageSpaceMedias(),
      VIEW_TYPES,
      activationTypesTokenOptions: getDialogOfActivationTypes(),
      modelName: this.$route.meta.modelName,
      storageSpaceMediaTypeToken: this.$route.meta.storageSpaceMediaTypeToken,
      mainToken: this.$route.params.mainToken,
      storageSpaceToken: this.$route.params.storageSpaceToken,
    };
  },
  methods: {
    checkPrivilege,
    fullPathFileFromServer,
    changePagination(pagination) {
      this.storageSpaceMedias.filterData.fillData(pagination);
      this.getAllStorageSpaceMedias();
    },
    changeActivationType(data) {
      this.updateActivationTypeTokens(this.modelName, data);
      this.storageSpaceMedias.filterData.activationTypeTokens = data;
      this.getAllStorageSpaceMedias();
    },
    search(data) {
      this.storageSpaceMedias.filterData.fillData(data);
      this.getAllStorageSpaceMedias();
    },
    async getAllStorageSpaceMedias() {
      this.isLoading = true;
      try {
        this.storageSpaceMedias.filterData.activationTypeTokens =
          this.generalSetting[this.modelName].activationTypeTokens;
        this.storageSpaceMedias.filterData.storageSpaceMediaTypeToken =
          this.storageSpaceMediaTypeToken;

        this.storageSpaceMedias.storageSpaceMediaData = [];
        const response = await apiStorageSpaceMedia.getAll(
          this.storageSpaceMedias.filterData
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.exceptionMsg = null;
        } else if (response.data.status == STATUS.NO_INTERNET) {
          this.exceptionMsg = response.data.msg;
          this.exceptionImg = "illustrator-noInternet.svg";
        } else if (response.data.status == STATUS.NO_CONTENT) {
          this.exceptionMsg = response.data.msg;
          this.exceptionImg = "illustrator-noData.svg";
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
        } else {
          this.exceptionMsg = response.data.msg;
          this.exceptionImg = null;
        }
        this.storageSpaceMedias.fillData(response.data);
      } catch (error) {
        this.exceptionMsg = this.$t("errorCatch");
        this.exceptionImg = null;
      }
      this.isLoading = false;
    },

    getActivationTypeTokenOptionAdminsEgypt() {
      let arr = [];
      if (checkPrivilege(hasStorageSpaceMediaAdminsEgyptViewActive())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Active
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalActiveCount || 0;
        if (obj) arr.push(obj);
      }
      if (checkPrivilege(hasStorageSpaceMediaAdminsEgyptViewArchive())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Archived
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalArchivedCount || 0;
        if (obj) arr.push(obj);
      }
      if (checkPrivilege(hasStorageSpaceMediaAdminsEgyptViewBlocked())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Blocked
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalBlockedCount || 0;
        if (obj) arr.push(obj);
      }

      return arr;
    },
    getActivationTypeTokenOptionMasterAdmin() {
      let arr = [];
      if (checkPrivilege(hasStorageSpaceMediaMasterAdminViewActive())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Active
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalActiveCount || 0;
        if (obj) arr.push(obj);
      }
      if (checkPrivilege(hasStorageSpaceMediaMasterAdminViewArchive())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Archived
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalArchivedCount || 0;
        if (obj) arr.push(obj);
      }
      if (checkPrivilege(hasStorageSpaceMediaMasterAdminViewBlocked())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Blocked
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalBlockedCount || 0;
        if (obj) arr.push(obj);
      }

      return arr;
    },
    getActivationTypeTokenOptionEmployees() {
      let arr = [];
      if (checkPrivilege(hasStorageSpaceMediaEmployeeViewActive())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Active
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalActiveCount || 0;
        if (obj) arr.push(obj);
      }
      if (checkPrivilege(hasStorageSpaceMediaEmployeeViewArchive())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Archived
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalArchivedCount || 0;
        if (obj) arr.push(obj);
      }
      if (checkPrivilege(hasStorageSpaceMediaEmployeeViewBlocked())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Blocked
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalBlockedCount || 0;
        if (obj) arr.push(obj);
      }

      return arr;
    },
    getActivationTypeTokenOptionStudent() {
      let arr = [];
      if (checkPrivilege(hasStorageSpaceMediaStudentViewActive())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Active
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalActiveCount || 0;
        if (obj) arr.push(obj);
      }
      if (checkPrivilege(hasStorageSpaceMediaStudentViewArchive())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Archived
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalArchivedCount || 0;
        if (obj) arr.push(obj);
      }
      if (checkPrivilege(hasStorageSpaceMediaStudentViewBlocked())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Blocked
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalBlockedCount || 0;
        if (obj) arr.push(obj);
      }

      return arr;
    },
    getActivationTypeTokenOptionPlaces() {
      let arr = [];
      if (checkPrivilege(hasStorageSpaceMediaPlaceViewActive())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Active
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalActiveCount || 0;
        if (obj) arr.push(obj);
      }
      if (checkPrivilege(hasStorageSpaceMediaPlaceViewArchive())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Archived
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalArchivedCount || 0;
        if (obj) arr.push(obj);
      }
      if (checkPrivilege(hasStorageSpaceMediaPlaceViewBlocked())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Blocked
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalBlockedCount || 0;
        if (obj) arr.push(obj);
      }

      return arr;
    },
    getActivationTypeTokenOptionEducationalGroup() {
      let arr = [];
      if (checkPrivilege(hasStorageSpaceMediaEducationalGroupViewActive())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Active
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalActiveCount || 0;
        if (obj) arr.push(obj);
      }
      if (checkPrivilege(hasStorageSpaceMediaEducationalGroupViewArchive())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Archived
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalArchivedCount || 0;
        if (obj) arr.push(obj);
      }
      if (checkPrivilege(hasStorageSpaceMediaEducationalGroupViewBlocked())) {
        let obj = this.activationTypesTokenOptions.find(
          (e) => e.value === ACTIVATION_TYPE.Blocked
        );
        obj.totalNumber =
          this.storageSpaceMedias.storageSpaceMediaStatistics
            .totalBlockedCount || 0;
        if (obj) arr.push(obj);
      }

      return arr;
    },

    filterByMediaType(mediaTypeToken) {
      this.currentTab = mediaTypeToken;
      this.storageSpaceMedias.filterData.storageSpaceMediaFileTypeToken =
        mediaTypeToken;
      this.getAllStorageSpaceMedias();
    },
  },
  async created() {
    this.storageSpaceMedias.filterData.mainToken = this.mainToken;
    this.storageSpaceMedias.filterData.storageSpaceToken =
      this.storageSpaceToken;

    this.currentTab = this.mediaTypesOptions[0].value;
    this.storageSpaceMedias.filterData.storageSpaceMediaFileTypeToken =
      this.currentTab;
    this.getAllStorageSpaceMedias();
  },
};
</script>
